var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.loading)?_c('CrudIndex',{attrs:{"title":"Asset Logs","allowEditing":false,"permission":_vm.PERMISSION_CODES.VIEW_ASSET_LOGS,"viewColumns":_vm.columns,"fetchUrl":"/asset-logs","reloadOnSuccess":true,"createFields":_vm.createFields}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }